// extracted by mini-css-extract-plugin
export default {"end-button":"VotesResultsView_end-button__ru9+E"};